module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em",
      "padding-top": "15px"
    }
  }, [_vm._v("Christine Sinclair, my meditation teacher and guide in Adelaide, Australia in 2004, who supported me in my spiritual development and growth, encouraging me to take the stand, so to speak, and run a class in her absence. Thank you for the confidence you had in me, my vision and voice, and my blossoming work. I am truly grateful.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em",
      "padding-top": "15px"
    }
  }, [_vm._v("To my mum and to my sisters, Lorraine, Maureen and Wendy, who have always been inspiring and magical, as we would talk about all things spiritual. For keeping the child-like wonder very much alive in me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em",
      "padding-top": "15px"
    }
  }, [_vm._v("To Poppy Evans, and Anne-Marie Birch, my longest standing mentees in the circle over the years and wonderful supporters and friends.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em",
      "padding-top": "15px"
    }
  }, [_vm._v("To Nicola (Haynes) Tillbrook, for your constant belief in all the spiritual things I do. For absolutely just ‘getting me’. Period.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em",
      "padding-top": "15px"
    }
  }, [_vm._v("Lorraine White, Calmblue Clinic, Edinburgh, for understanding what my work is all about and supporting me through the clinic to grow. You have been so pivotal in my success. Thank you.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em",
      "padding-top": "15px"
    }
  }, [_vm._v("To each of my attendees/friends who have journeyed within themselves during a period of time with me in the Rainbow Path Circles. I appreciate and value each and every one of you. Thank you to those beautiful tribe members who shared their visions or experiences within these pages.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em",
      "padding-top": "15px"
    }
  }, [_vm._v("To Great Mother, Great Spirit Mother/Father God, all the Ascended Masters, Archangels, Spirit, Animal Guides, and all who have come through my meditations to share their light and wisdom.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em",
      "padding-top": "15px"
    }
  }, [_vm._v("Stephanie Jeffery, my proof reader, sub-editor, and lovely friend. Thank you for bringing your insights and your knowledge to this wonderful project along with your unwavering faith and belief in it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a9da684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch003.vue
// module id = 69
// module chunks = 0